export default __webpack_public_path__ + "static/media/Punto_04_Finocchietti_ENG_Def.44b860d9.aac";